import React from "react";
import { Modal, message } from "antd";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import { isPrepareBillModificationBlocked, PREPARE_BILL_MODIFICATION_BLOCKED_MESSAGE } from "../../../../utils/prepareBillModificationGuard";

const SaleTypeModal = ({
  saleTypeModalOpen,
  setSaleTypeModalOpen,
  saleTypeModalItem,
  cart,
  setCart,
}) => {
  const applySaleType = (saleType) => {
    // TSK-3303: backstop in case this modal was already open when Prepare
    // Bill confirmed the order (its opener is gated in CartOrderSidebar.js).
    if (isPrepareBillModificationBlocked(cart, usePOSConfigStore.getState().posConfig)) {
      message.info(PREPARE_BILL_MODIFICATION_BLOCKED_MESSAGE);
      setSaleTypeModalOpen(false);
      return;
    }
    const updatedItems = cart.items.map((i) => (i.lineId === saleTypeModalItem.lineId ? { ...i, saleType } : i));
    setCart({ ...cart, items: updatedItems });
    setSaleTypeModalOpen(false);
  };

  return (
    <Modal
      open={saleTypeModalOpen}
      onCancel={() => setSaleTypeModalOpen(false)}
      footer={null}
      centered
      closable={true}
      maskClosable={true}
      width={420}
      styles={{ body: {
        height: "380px",
        padding: "20px",
        background: "#ffffff",
      } }}
      className="production-center-modal"
      title={
        <div
          style={{
            fontSize: "1.25rem",
            fontWeight: 600,
            color: "#0F0718",
            marginBottom: "16px",
          }}
        >
          Order Type
        </div>
      }
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "12px",
        }}
      >
        <div
          onClick={() => applySaleType("DI")}
          style={{
            border: saleTypeModalItem?.saleType === "DI" ? "2px solid #f3f4f9" : "1px solid #d9d9d9",
            background: saleTypeModalItem?.saleType === "DI" ? "#9fa4ae" : "#ffffff",
            padding: "16px 0",
            borderRadius: "12px",
            textAlign: "center",
            fontSize: "1rem",
            fontWeight: 500,
            color: "#0F0718",
            cursor: "pointer",
            transition: "all 0.2s",
          }}
        >
          Dine In
        </div>

        <div
          onClick={() => applySaleType("TA")}
          style={{
            border: saleTypeModalItem?.saleType === "TA" ? "2px solid #f3f4f9" : "1px solid #d9d9d9",
            background: saleTypeModalItem?.saleType === "TA" ? "#9fa4ae" : "#ffffff",
            padding: "16px 0",
            borderRadius: "12px",
            textAlign: "center",
            fontSize: "1rem",
            fontWeight: 500,
            color: "#0F0718",
            cursor: "pointer",
            transition: "all 0.2s",
          }}
        >
          Take Away
        </div>
      </div>
    </Modal>
  );
};

export default SaleTypeModal;
